  import esquire from "@/types/clients/esquire";
  import LogIn from "@/types/clients/esquire/requests/auth/log-in";
  import ReservationLogIn from "@/types/clients/esquire/requests/auth/reservation-log-in";
  import GetContractStatus from "@/types/clients/esquire/requests/general/get-contract-status";
  import GetRoutesAndCrm from "@/types/clients/esquire/requests/auth/get-routes-and-crm";

  export const logInRequest = new LogIn(esquire);
  export const reservationLogInRequest = new ReservationLogIn(esquire);
  export const getContractStatus = new GetContractStatus(esquire);
  export const getRoutesAndCrm = new GetRoutesAndCrm(esquire);

  export class LoginService {  }
